import styled from 'styled-components';

import { MOBILE_MAX_WIDTH_SIGNUP } from 'pages/authentication/sign-up/constants';
import { primitive } from 'styles/constants/primitives';

export const SignUpHeader = styled.div`
  display: none;
  @media screen and (max-width: ${MOBILE_MAX_WIDTH_SIGNUP}) {
    display: flex;
    height: ${primitive.$spacing10};
    width: 100%;
    background-color: ${p => p.theme.token('background-default')};
    padding: calc(${primitive.$spacing4} + env(safe-area-inset-top)) 6% ${primitive.$spacing4} 6%;
  }

  ${Styles.mobileTiny`
    position: fixed;
    top: 0px;
    z-index: 500;

  `}
`;
export const BackArrowContainer = styled.div``;
